module.exports = "https://d1tntvpcrzvon2.cloudfront.net/vpassets/_next/static/images/theme-mostpopular-4-902d24fc1b6d365c36d8ed46a187dd08.webp";